<template>
  <div class="page-personal-base">
    <div class="inner-personal">

      <div class="box">
        <h1>个人资料</h1>

        <a class="m-btn" @click="goBack">
          <img src="../../assets/images/back.png" alt="">
        </a>
      </div>
      <div class="list">
        <div class="item">
          <div class="tit">姓名</div>
          <div class="con">
            <span>{{ userData.userName }}</span>
            <span class="m-btn fr" @click="editName">修改</span>
          </div>
        </div>

        <div class="item">
          <div class="tit">头像</div>
          <div class="con">
            <span>
              <img class="g-pic small" :src="userData.headImg || ''" alt :onerror="defaultHeadImg" />
            </span>
            <span class="m-btn fr">
              <!-- 上传 -->
              <cmp-upload ref="myUpload" :actionUrl="'/singleMuseum/user/updateUserImg'" :businessType="``" :callEveryFun="uploadCallback" :hasIcon="false" :conacat="false"></cmp-upload>
            </span>
          </div>
        </div>

        <div class="item">
          <div class="tit">密码</div>
          <div class="con">
            <span>******</span>
            <span class="m-btn fr" @click="showDialog('reset')">修改</span>
          </div>
        </div>

        <div class="item">
          <div class="tit">绑定手机</div>
          <div class="con">
            <span>{{ userData.phone.substring(0, 3) }}****{{
              userData.phone.substring(7)
            }}</span>
            <span class="m-btn fr" @click="showDialog('phone')">更换</span>
          </div>
        </div>

        <div class="item">
          <div class="tit">绑定微信</div>
          <div class="con">
            <span>
              <!-- <img class="g-pic small" :src="''" alt :onerror="defaultHeadImg" /> -->
              <svg-icon icon-class="wechat" style="font-size:26px;vertical-align:middle;" v-show="isBind"></svg-icon>
              <!-- 胡强 -->
            </span>
            <span class="m-btn fr" v-show="!isBind" @click="handleWechat">绑定</span>
          </div>
        </div>
      </div>

      <div class="code-mask" v-if="codeVisible">
        <div class="code-wrap">
          <p class="title">微信登录</p>
          <img :src="codeUrl" alt="" />
          <div class="info">
            <p class="tips">请使用微信扫描二维码登录</p>
          </div>
        </div>
      </div>

      <dialogModifyBase ref="dialogModifyBase"></dialogModifyBase>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import cmpUpload from '@cmp/my-upload/index'
import dialogModifyBase from './dialog-modify-base'
import { setCookieEncrypt } from '@/utils/util'
export default {
  components: { cmpUpload, dialogModifyBase },
  computed: {
    userData() {
      return this.$store.state.user
    }
  },
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      codeVisible: false,
      codeUrl: '',
      isBind: false
    }
  },
  methods: {
    showDialog(type) {
      this.$refs.dialogModifyBase.init(type)
    },
    handleWechat() {
      this.codeVisible = true

      this.$http
        .post('/wx/wxQrcode.do', {})
        .then((res) => {
          if (res.success) {
            this.codeUrl = res.result.url
          } else {
            this.$message.error(res.message)
          }
        })

      // 开发环境不循环 便于查看控制台
      // if (process.env.VUE_APP_START_INTERVAL === '1') {
      if (window.InitSetInterval3) {
        clearInterval(window.InitSetInterval3)
      }
      window.InitSetInterval3 = setInterval(() => {
        this.getInfo()
      }, 5000)
      // }
    },
    getInfo() {
      this.$http
        .post('/wx/wxQrcode.do', {})
        .then((res) => {
          if (res.success) {
            if (res.result.bind || res.result.timeout) {
              if (res.result.bind) {
                this.isBind = true
                // 覆盖用户头像
                this.$store.state.user.headImg = res.result.headImg
                Cookies.set('headImg', res.result.headImg, { expires: 7 })
              }
              clearInterval(window.InitSetInterval3)
              this.codeVisible = false
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    editName() {
      this.$prompt('', '修改姓名', {
        showClose: true,
        showCancelButton: true,
        confirmButtonText: '确定',
        inputPlaceholder: '请输入',
        inputValue: this.userData.userName,
        // inputValue: title ? data.label : null,
        inputPattern: /^.{1,10}$/,
        inputErrorMessage: '请输入1到10位字符'
        // center: true
      })
        .then(({ value }) => {
          this.$http
            .post('/user/updateUserName', {
              userId: this.userData.userid,
              userName: value
            })
            .then((res) => {
              if (res.success) {
                this.$store.dispatch('setUserIfo', {
                  ...this.userData,
                  userName: value
                })
                setCookieEncrypt('userName', value)
                this.$message.success('修改姓名成功')
              } else {
                this.$message.error(res.message)
              }
            })
        })
        .catch(() => { })
    },
    // 上传回调
    uploadCallback(item) {
      this.$store.state.user.headImg = item.attPath
      Cookies.set('headImg', item.attPath, { expires: 7 })
    },

    goBack() {
      this.$router.go(-1)
    },
  },
  created() {
    // 后台存到cookie中的的是否绑定微信字段
    this.isBind = Cookies.get('openId')
  },
  beforeDestroy() {
    if (window.InitSetInterval3) {
      clearInterval(window.InitSetInterval3)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-personal-base {
  width: 960px;
  margin: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .inner-personal {
    width: 100%;
    padding: 51px 40px;

    border-radius: 4px;
    border-color: #e3e3e3;
    box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.12);
    .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      h1 {
        margin-bottom: 0;
      }
      img{
        width: 32px;
      }
    }
  }
  .list {
    .item {
      display: flex;
      line-height: 60px;
      border-bottom: solid 1px $border;
      font-size: 14px;
      color: $color5;
      .tit {
        width: 300px;
      }
      .con {
        flex: 1;
        color: $color6;
      }
    }
  }

  .code-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9;
    background: rgb(51, 51, 51);
    padding: 50px;
    box-sizing: border-box;
    .code-wrap {
      color: #fff;
      text-align: center;
      line-height: 1.5;
      .title {
        font-size: 20px;
      }
      img {
        margin: 15px 0;
        width: 280px;
      }
      .info {
        width: 280px;
        margin: 0 auto;
        font-size: 14px;
        .tips {
          padding: 8px 0;
          background-color: #232323;
          border-radius: 100px;
          box-shadow: inset 0 5px 10px -5px #191919, 0 1px 0 0 #444;
        }
      }
    }
  }
}
</style>

